import { render, staticRenderFns } from "./TsMenuButton.vue?vue&type=template&id=6d559c1b&scoped=true&"
import script from "./TsMenuButton.vue?vue&type=script&lang=js&"
export * from "./TsMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d559c1b",
  null
  
)

export default component.exports